export async function getIPbyCountry(ip) {
  return await fetch("https://api.country.is/" + ip)
    .then((res) => res.json())
    .catch((err) => {
      console.log(err);
    });
}
